import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { datadogRum } from '@datadog/browser-rum';

export interface NativeShellInfo {
    build: string;
    version: string;
}

/** `Capacitor.getPlatform()` returns 'android', 'ios', or 'web'. */
export function getAppPlatform(): string {
    return Capacitor.getPlatform();
}

async function readShellInfo(): Promise<NativeShellInfo | null> {
    if (!Capacitor.isNativePlatform()) {
        return null;
    }
    try {
        const { build, version } = await App.getInfo();
        return { build, version };
    } catch (error) {
        datadogRum.addError(error, { context: 'readNativeShellInfo' });
        return null;
    }
}

// The shell version never changes within a session, and both telemetry sinks want it, so the bridge
// round-trip is memoised rather than repeated per consumer.
let shellInfo: Promise<NativeShellInfo | null> | undefined;

/**
 * Reads the wrapper's version and build number. Returns null in a browser, and also when the call
 * fails, so a shell that predates the plugin cannot break the web app.
 */
export function readNativeShellInfo(): Promise<NativeShellInfo | null> {
    shellInfo ??= readShellInfo();
    return shellInfo;
}
